import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Observable } from 'rxjs';
import { apiLink } from '../../../constant/api-link';
import { BannerFetchData, BannerModel } from '../../../model/builk/banner-list/BannerFetchData.model';

@Injectable({
  providedIn: 'root'
})

export class BannerListService {

constructor(
  private http: HttpClient,
  private localStorageService: LocalStorageService
) { }

  fetchBanner(model: BannerFetchData): Observable<any> {
    const url = apiLink.getBanner;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    let params = new HttpParams();
    params = params.append("Page", model.page.toString());
    params = params.append("ItemPerPage", model.itemPerPage.toString());
    return this.http.get<any>(url, {
      headers: headers,
      params: params
    })
  }

  createBanner(model: BannerModel): Observable<any> {
    const url = apiLink.createBanner;
    let body = new FormData();
    if(model.bannerImageDesktop) {
      body.append("bannerImageDesktop", model.bannerImageDesktop);
    }
    if(model.bannerImageDesktop) {
      body.append("bannerImageMobile", model.bannerImageMobile);
    }
    body.append("bannerId", this.localStorageService.get("userSurrKey"));
    body.append("bannerName", model.bannerName);
    body.append("bannerActive", model.bannerActive.toString());
    body.append("bannerAction", model.bannerAction);
    body.append("bannerPage", model.bannerPage.toString());
    body.append("bannerType", model.bannerType.toString());
    return this.http.post<any>(url, body);
  }

  updateBanner(model: BannerModel): Observable<boolean> {
    const url = apiLink.updateBanner;
    let body = new FormData();
    if(model.bannerImageDesktop) {
      body.append("bannerImageDesktop", model.bannerImageDesktop);
    }
    if(model.bannerImageMobile) {
      body.append("bannerImageMobile", model.bannerImageMobile);
    }
    body.append("bannerId", this.localStorageService.get("userSurrKey"));
    body.append("bannerName", model.bannerName);
    body.append("bannerActive", model.bannerActive.toString());
    body.append("bannerAction", model.bannerAction);
    body.append("bannerPage", model.bannerPage.toString());
    body.append("bannerType", model.bannerType.toString());
    body.append("bannerSurrId", model.bannerSurrId.toString());
    return this.http.patch<any>(url, body);
  }
}
